import React, { useContext, useState } from 'react'
import Select from 'react-dropdown-select';
import SuperAdminContext from '../../../hooks/SuperAdminContext';
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from "react-google-autocomplete";
import { IoClose } from 'react-icons/io5';
import { handleGoogleApiLocation, handleInput } from 'Actions/commonAction/milleSearchFilterActions';

const ProfessionalFilter = ({
  setSelectedProfilePercentage, selectedProfilePercentage, profilePercentageData,
  mellieSearchPlans, setMellieSearchPlans, planData, skillData, initialGlow,
  mellieSearchSkills, setMellieSearchSkills, handleMellieSearch,
  professionalFunctionalSpeci, professionalGender, professionalIndustrySector,
  professionalJobType, professionalModeOfCommunication, professionalSector,
  professionalRelocate, professionalLocPref, professionalFilterGender, setProfessionalFilterGender,
  setProfessionalModeOfCommunication, setProfessionalIndustrySector, setProfessionalSector,
  setProfessionalFunctionalSpeci, professionalFilterIndustrySector, setProfessionalFilterIndustrySector,
  professionalFilterJobType, setProfessionalFilterJobType,
  professionalFilterModeOfCommunication, setProfessionalFilterModeOfCommunication,
  professionalFilterSector, setProfessionalFilterSector,
  professionalFilterRelocate, setProfessionalFilterRelocate,
  professionalFilterLocPref, setProfessionalFilterLocPref,
  professionalFilterFunctionalSpeci, setProfessionalFilterFunctionalSpeci,
}) => {
  const { location, enteredInputLocation } = useSelector((state) => state.milleSearchStates);
  const dispatch = useDispatch();

  const { setProfessionalSkillConvertion } = useContext(SuperAdminContext);

  const [skillsSearch, setSkillsSearch] = useState(true);

  const handleSkills = (skillsValue) => {
    setMellieSearchSkills(skillsValue)

    if (skillsValue.length > 0) {
      const checkIfValueIsOthers = skillsValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = skillData.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalSkillConvertion(ChangeOtherValuesToDisable)
        setSkillsSearch(false)
      } else {
        const ChangeOtherValuesToDisable = skillData.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalSkillConvertion(ChangeOtherValuesToDisable)
        setSkillsSearch(true)
      }
    } else {
      const ChangeDisableFalse = skillData.map((skills) => {
        return { ...skills, disabled: false }
      })
      setProfessionalSkillConvertion(ChangeDisableFalse)
      setSkillsSearch(true)
    }
  }

  const handlePlans = (plansValue) => {
    setMellieSearchPlans(plansValue)
  }

  const handleIndustrySector = (industrySectorValue) => {
    setProfessionalFilterIndustrySector(industrySectorValue)

    if (industrySectorValue.length > 0) {
      const checkIfValueIsOthers = industrySectorValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = professionalIndustrySector.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalIndustrySector(ChangeOtherValuesToDisable)
      } else {
        const ChangeOtherValuesToDisable = professionalIndustrySector.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalIndustrySector(ChangeOtherValuesToDisable)
      }
    } else {
      const ChangeDisableFalse = professionalIndustrySector.map((skills) => {
        return { ...skills, disabled: false }
      })
      setProfessionalIndustrySector(ChangeDisableFalse)
    }
  }

  const handleSector = (sectorValue) => {
    setProfessionalFilterSector(sectorValue)

    if (sectorValue.length > 0) {
      const checkIfValueIsOthers = sectorValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = professionalSector.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalSector(ChangeOtherValuesToDisable)
      } else {
        const ChangeOtherValuesToDisable = professionalSector.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalSector(ChangeOtherValuesToDisable)
      }
    } else {
      const ChangeDisableFalse = professionalSector.map((skills) => {
        return { ...skills, disabled: false }
      })
      setProfessionalSector(ChangeDisableFalse)
    }
  }

  const handleFunctionalSpeci = (functionalSpeciValue) => {
    setProfessionalFilterFunctionalSpeci(functionalSpeciValue)

    if (functionalSpeciValue.length > 0) {
      const checkIfValueIsOthers = functionalSpeciValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = professionalFunctionalSpeci.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalFunctionalSpeci(ChangeOtherValuesToDisable)
      } else {
        const ChangeOtherValuesToDisable = professionalFunctionalSpeci.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalFunctionalSpeci(ChangeOtherValuesToDisable)
      }
    } else {
      const ChangeDisableFalse = professionalFunctionalSpeci.map((skills) => {
        return { ...skills, disabled: false }
      })
      setProfessionalFunctionalSpeci(ChangeDisableFalse)
    }
  }

  const handleModeOfCommuni = (modeOfCommuniValue) => {
    setProfessionalFilterModeOfCommunication(modeOfCommuniValue)

    if (modeOfCommuniValue.length > 0) {
      const checkIfValueIsOthers = modeOfCommuniValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = professionalModeOfCommunication.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalModeOfCommunication(ChangeOtherValuesToDisable)
      } else {
        const ChangeOtherValuesToDisable = professionalModeOfCommunication.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setProfessionalModeOfCommunication(ChangeOtherValuesToDisable)
      }
    } else {
      const ChangeDisableFalse = professionalModeOfCommunication.map((skills) => {
        return { ...skills, disabled: false }
      })
      setProfessionalModeOfCommunication(ChangeDisableFalse)
    }
  }

  return (
    <div className="container">
      <div className="row g-2 p-3">
        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Skills</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={mellieSearchSkills.length < 5 ? skillData : []}
                  addPlaceholder={skillsSearch ? "Select up to 5 Skills" : ""}
                  onChange={(values) => handleSkills(values)}
                  values={mellieSearchSkills}
                  searchable={skillsSearch}
                />
              </>
            )}
          </div>
        </div>

        <div className='mb-4'>
          <h6 className='fw-bold'>Plan</h6>
          <Select
            color='#ffa32d'
            style={{ fontSize: ".9rem" }}
            className='rounded-1'
            options={planData}
            onChange={handlePlans}
            values={mellieSearchPlans}
            searchable={skillsSearch}
          />
        </div>

        <div className='mb-4'>
          <h6 className='fw-bold'>Profile percentage</h6>
          <Select
            color='#ffa32d'
            style={{ fontSize: ".9rem" }}
            className='rounded-1'
            options={profilePercentageData}
            onChange={(e) => setSelectedProfilePercentage(e)}
            values={selectedProfilePercentage}
          />
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ?
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
              :
              <div className='mb-4'>
                <h6 className='fw-bold'>Location</h6>
                <div className={location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                  {location.map((v) => (
                    <div className="col-6 py-1 pe-1">
                      <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                        <div className="col-10">
                          <p className='w-100 mb-0 text-break'>{v}</p>
                        </div>
                        <div className="col-2">
                          <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                  className='google-places-api '
                  onPlaceSelected={(place) => {
                    if (place) {
                      dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                    }
                  }}
                  onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                  value={enteredInputLocation}
                  disabled={location.length === 5}
                />
              </div>
            }
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Gender</h6>
                <Select
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterGender.length < 5 ? professionalGender : []}
                  onChange={(values) => setProfessionalFilterGender(values)}
                  values={professionalFilterGender}
                  searchable={skillsSearch}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Industry Sector</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterIndustrySector?.length < 5 ? professionalIndustrySector : []}
                  addPlaceholder={"Select up to 5 Industry sector"}
                  onChange={(values) => handleIndustrySector(values)}
                  values={professionalFilterIndustrySector}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Sector</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterSector.length < 5 ? professionalSector : []}
                  addPlaceholder="Select up to 5 Sectors"
                  onChange={(values) => handleSector(values)}
                  values={professionalFilterSector}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Job Type</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterJobType.length < 5 ? professionalJobType : []}
                  onChange={(values) => setProfessionalFilterJobType(values)}
                  values={professionalFilterJobType}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Willing to relocate</h6>
                <Select
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterRelocate.length < 5 ? professionalRelocate : []}
                  onChange={(values) => setProfessionalFilterRelocate(values)}
                  values={professionalFilterRelocate}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Location preference</h6>
                <Select
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterLocPref.length < 5 ? professionalLocPref : []}
                  onChange={(values) => setProfessionalFilterLocPref(values)}
                  values={professionalFilterLocPref}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Functional specification</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterFunctionalSpeci.length < 5 ? professionalFunctionalSpeci : []}
                  addPlaceholder="Select up to 5 Funct..."
                  onChange={(values) => handleFunctionalSpeci(values)}
                  values={professionalFilterFunctionalSpeci}
                />
              </>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="mb-4">
            {initialGlow ? (
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
            ) : (
              <>
                <h6 className="fw-bold">Mode of communication</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={professionalFilterModeOfCommunication.length < 5 ? professionalModeOfCommunication : []}
                  onChange={(values) => handleModeOfCommuni(values)}
                  values={professionalFilterModeOfCommunication}
                />
              </>
            )}
          </div>
        </div>

        <button type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn" onClick={() => {
          handleMellieSearch("ApplyFilter")
        }}>Apply Filter</button>

      </div>
    </div>
  );
};

export default ProfessionalFilter